import { gql } from '@apollo/client';

export const ALL_SERVICE_PROVIDER_USERS = gql`
  query AllServiceProviderUsers($input: UserFilterInput!) {
    users: allServiceProviderUsers(input: $input) {
      createdAt
      id
      updatedAt
      email
      firstName
      lastName
      status
      lastLogin
      contactNumber
      designation
      activities {
        id
      }
      authMetaData {
        id
        duration
      }
      organisations {
        id
        status
        role {
          id
          name
        }
        practitionerType
        organisation {
          id
          isServiceProvider
          serviceProvider {
            id
            name
          }
        }
      }
    }
  }
`;
